import { initProductOffer } from "./extend-product.js";
import { initCartOffer } from "./extend-cart.js";
import { getConfiguration, verifyExtend, ExtendError } from "./extend-utils.js"

// Store password is rohwee
(() => {
    try {
        const storeId = '63dae2fd-e2e9-4cf4-82b4-728d0ed5fc8b';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
})();

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}